import { useMemo, useState } from 'react'

const toggle = (prev: boolean) => !prev

export function useSwitcher(initialValue = false) {
	const [value, setValue] = useState(initialValue)
	const methods = useMemo(
		() => ({
			off: () => setValue(false),
			on: () => setValue(true),
			toggle: () => setValue(toggle)
		}),
		[]
	)

	return Object.assign(methods, { isOn: value })
}
